import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  max-width: 868px;
  margin-bottom: 24px;
`

const Title = styled.div`
  color: black;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 8px;

  @media (max-width: 800px) {
    font-size: 20px;
  }
`

const Description = styled.div`
  color: black;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: -0.02em;
  line-height: 1.4;

  @media (max-width: 800px) {
    font-size: 14px;
  }
`

export const AIMetadata = ({ aiTitle, aiDescription }) => {
  if (!aiTitle && !aiDescription) {
    return null
  }

  return (
    <Container>
      {aiTitle && <Title>{aiTitle}</Title>}
      {aiDescription && <Description>{aiDescription}</Description>}
    </Container>
  )
}
